import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../icon.interface';

const HomeIcon = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <path
          d="M26 27V14H3V27C3 28.6569 4.34315 30 6 30H23C24.6569 30 26 28.6569 26 27Z"
          fill="white"
        />
        <path
          d="M6 30V20C6 18.8954 6.89543 18 8 18H13C14.1046 18 15 18.8954 15 20V30H6Z"
          fill="#E4E0FF"
        />
        <path d="M3 14H26V16H3V14Z" fill="#E4E0FF" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.75 14V27C3.75 28.2426 4.75736 29.25 6 29.25H23C24.2426 29.25 25.25 28.2426 25.25 27V14H26.75V27C26.75 29.0711 25.0711 30.75 23 30.75H6C3.92893 30.75 2.25 29.0711 2.25 27V14H3.75Z"
          fill="#0F3893"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13 18.75C13.6904 18.75 14.25 19.3096 14.25 20V30C14.25 30.4142 14.5858 30.75 15 30.75C15.4142 30.75 15.75 30.4142 15.75 30V20C15.75 18.4812 14.5188 17.25 13 17.25H8C6.48122 17.25 5.25 18.4812 5.25 20V30C5.25 30.4142 5.58579 30.75 6 30.75C6.41421 30.75 6.75 30.4142 6.75 30V20C6.75 19.3096 7.30964 18.75 8 18.75H13Z"
          fill="#0F3893"
        />
        <path
          d="M23 24V21C23 19.3431 21.6569 18 20 18C18.3431 18 17 19.3431 17 21V24H23Z"
          fill="#C0AAFE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20 18.75C18.7574 18.75 17.75 19.7574 17.75 21V23.25H22.25V21C22.25 19.7574 21.2426 18.75 20 18.75ZM16.25 21C16.25 18.9289 17.9289 17.25 20 17.25C22.0711 17.25 23.75 18.9289 23.75 21V24.75H16.25V21Z"
          fill="#0F3893"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 23.375C8.34518 23.375 8.625 23.6548 8.625 24V25.75C8.625 26.0952 8.34518 26.375 8 26.375C7.65482 26.375 7.375 26.0952 7.375 25.75V24C7.375 23.6548 7.65482 23.375 8 23.375Z"
          fill="#0F3893"
        />
        <path
          d="M27 13.5H2L7.42627 8.52572C7.79513 8.18758 8.27735 8 8.77775 8H20.2218C20.7222 8 21.2044 8.18756 21.5732 8.52566L27 13.5Z"
          fill="#006DFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.602102 14.0438C0.377851 13.4673 0.530477 12.8123 0.98645 12.3943L6.41272 7.42001C7.05823 6.82827 7.90211 6.5 8.7778 6.5H20.2219C21.0975 6.5 21.9414 6.82823 22.5869 7.41991L21.5733 8.52566C21.2044 8.18756 20.7222 8 20.2219 8H8.7778C8.27741 8 7.79519 8.18758 7.42633 8.52572L2.00006 13.5H27.0001L21.5733 8.52566L22.5869 7.41991L28.0136 12.3942C28.4696 12.8122 28.6223 13.4673 28.398 14.0438C28.1738 14.6203 27.6186 15 27.0001 15H2.00006C1.38149 15 0.826354 14.6203 0.602102 14.0438Z"
          fill="#0F3893"
        />
        <path
          d="M3 5C3 3.89543 3.89543 3 5 3H6C7.10457 3 8 3.89543 8 5V8L3 12.5V5Z"
          fill="#C0AAFE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 4.5H5C4.72386 4.5 4.5 4.72386 4.5 5V9.13196L6.5 7.33196V5C6.5 4.72386 6.27614 4.5 6 4.5ZM8 8V5C8 3.89543 7.10457 3 6 3H5C3.89543 3 3 3.89543 3 5V12.5L8 8Z"
          fill="#0F3893"
        />
        <path
          d="M20 4.5C20 3.94772 20.4477 3.5 21 3.5C21.5523 3.5 22 3.94772 22 4.5C22 5.05228 21.5523 5.5 21 5.5C20.4477 5.5 20 5.05228 20 4.5Z"
          fill="#006DFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.4697 7.53022C24.1768 7.23732 24.1768 6.76245 24.4697 6.46956L25.6235 5.31571C25.9164 5.02282 26.3913 5.02282 26.6842 5.31571C26.9771 5.6086 26.9771 6.08348 26.6842 6.37637L25.5303 7.53022C25.2374 7.82311 24.7626 7.82311 24.4697 7.53022Z"
          fill="#006DFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.3173 3.68403C28.0244 3.39113 28.0244 2.91626 28.3173 2.62337L29.4712 1.46952C29.7641 1.17663 30.2389 1.17663 30.5318 1.46952C30.8247 1.76241 30.8247 2.23729 30.5318 2.53018L29.378 3.68403C29.0851 3.97692 28.6102 3.97692 28.3173 3.68403Z"
          fill="#006DFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M30.5322 7.53033C30.2393 7.82322 29.7644 7.82322 29.4715 7.53033L28.3177 6.37648C28.0248 6.08359 28.0248 5.60872 28.3177 5.31582C28.6106 5.02293 29.0854 5.02293 29.3783 5.31582L30.5322 6.46967C30.8251 6.76256 30.8251 7.23744 30.5322 7.53033Z"
          fill="#006DFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.6845 3.68414C26.3916 3.97703 25.9167 3.97703 25.6239 3.68414L24.47 2.53029C24.1771 2.2374 24.1771 1.76253 24.47 1.46963C24.7629 1.17674 25.2378 1.17674 25.5307 1.46963L26.6845 2.62348C26.9774 2.91637 26.9774 3.39125 26.6845 3.68414Z"
          fill="#006DFF"
        />
      </svg>
    );
  }
);
export default HomeIcon;
